import React from 'react';
import './PartnershipAwards.css';

const PartnershipAwards = () => {
    return (
        <div className='partnership_awards'>
            <div className='container'>
                <div className="flex-container">
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-1.png" alt="" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-2.png" alt="" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-3.png" alt="" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-4.png" alt="" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-5.png" alt="" /></div>
                </div>
            </div>
        </div>
    )
};

export default PartnershipAwards;